// Live focus timer badge for an actively focused task.
import LiveFocusTimer from './LiveFocusTimer';

export function FocusedDurationBadge({
  focusStartTime,
  estimatedDuration,
  displayDuration,
  className,
}) {
  return (
    <LiveFocusTimer
      focusStartTime={focusStartTime}
      estimatedDuration={estimatedDuration ?? displayDuration}
      className={className}
    />
  );
}
